import {Directive, inject, ViewChild} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormGroup, FormGroupDirective} from '@angular/forms';

@Directive()
export abstract class ReactiveFormAbstract {

    @ViewChild(FormGroupDirective) ngForm!: FormGroupDirective;
    protected form!: FormGroup;
    protected fb!: FormBuilder;
    protected submitted: boolean = false;
    protected loading: boolean = false;

    protected constructor() {
        this.fb = inject(FormBuilder);
    }

    protected abstract submit(): void;

    protected abstract createForm(): FormGroup;

    onSubmit(): void {
        this.submitted = true;
        if (this.form.valid) {
            this.submit();
        } else {
            console.error('This form is invalid 😥', this.form);
            console.table(this.form.getRawValue())
            this.markAllFormFieldsAsTouched(this.form);
            this.goToAnchorWithError();
        }
    }

    markAllFormFieldsAsTouched(formGroup: any): void {
        Object.keys(formGroup.controls).forEach(field => {
            const control: AbstractControl | null = formGroup.get(field);
            if (control) {
                control.markAsDirty();
                control.markAsTouched();
                if (control instanceof FormGroup || control instanceof FormArray) {
                    this.markAllFormFieldsAsTouched(control);
                }
            }
        });
    }

    goToAnchorWithError(): void {
        setTimeout(() => {
            const isDialog = document.getElementsByTagName('ngb-modal-window').length > 0;
            if (!isDialog) {
                const diff = 200;
                const elementTarget = document.querySelector('.ng-invalid:not(forms)');

                if (elementTarget) {
                    const offsetTop = elementTarget.getBoundingClientRect().top + window.scrollY - diff;
                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    });
                }
            }
        });
    }

    getValue(field: string): any {
        return this.form.get(field)?.value;
    }

    getAsFormGroup(field: string): FormGroup {
        return this.form.get(field) as FormGroup;
    }

    get(field: string): AbstractControl | null {
        return this.form.get(field);
    }

    setValue(field: string, value: any): void {
        this.form.get(field)?.setValue(value);
    }

    getAsFormArray(field: string): FormArray | null {
        return this.form.get(field) as FormArray;
    }

    getACAsFormArray(field: AbstractControl | null | undefined): FormArray | null {
        return field as FormArray;
    }

    resetFormField = (controlName: string) => {
        const control = this.get(controlName);
        control?.setValue(null);
        control?.clearValidators();
        control?.updateValueAndValidity();
    };

    patchValue = (data: any) => {
        this.form.patchValue(data);
    }

    printValue(v: any): void {
        console.log(v);
    }

    printForm(): void {
        console.log(this.form);
    }

    getFormValue(): any {
        return this.form.getRawValue();
    }

    formIsDisabled(): boolean {
        return this.form.disabled || this.loading;
    }
}
